import store from '../store'

export function getLanguage(languages, userLanguageId, reload = false) {
    const localeQuery = new URL(location).searchParams.get('locale')
    const savedId = JSON.parse(localStorage.getItem('languageId'))
    let languageId
    if (localeQuery) {
      const newUrl = window.location.href.split("?")[0]
      window.history.replaceState({}, document.title, newUrl)
      const langFromURL = languages.find(l => l.code.startsWith(localeQuery.split('-')[0]))
      localStorage.setItem('languageCode', langFromURL.id)
      store.dispatch('common/SET_LANGUAGE', [languages.find(
        (l) => l.code.split('-')[0] === localeQuery.split('-')[0]
      ).id])
      store.dispatch('common/SET_LANGUAGE_CODE', [languages.find(
        (l) => l.code.split('-')[0] === localeQuery.split('-')[0]
      ).code])
      return languages.find(
        (l) => l.code.split('-')[0] === localeQuery.split('-')[0]
      )
    } 
    
    if (userLanguageId && !localeQuery) {
      
      if(!reload) {
        
        localStorage.setItem('languageId', userLanguageId)
        store.dispatch('common/SET_LANGUAGE', [userLanguageId])
        store.dispatch('common/SET_LANGUAGE_CODE', [languages.find(
          (l) => l.id === userLanguageId).code])
        languageId = userLanguageId
      } else {

        store.dispatch('common/SET_LANGUAGE', [savedId])
        store.dispatch('common/SET_LANGUAGE_CODE', [languages.find(
          (l) => l.id === savedId).code])
        languageId = savedId
      }
    } else {
      store.dispatch('common/SET_LANGUAGE', [savedId])
      store.dispatch('common/SET_LANGUAGE_CODE', [languages.find(
        (l) => l.id === savedId).code])
      languageId = savedId
    }

    return languages.find((l) => l.id === languageId)
  }